<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" class="home" :class="{scrolled: scrolled}"/>
    <NotFound v-if="!loading && !page"></NotFound>
    <template v-else>
      <div class="cnt bcCnt">
        <div class="breadcrumb bcSm bcSearch">
          <div class="bcItem"><a href="/">
            <template v-if="lang === 'id'">Beranda</template>
            <template v-if="lang === 'en'">Home</template>
          </a></div>
          <div class="bcItem">
            <span v-if="lang === 'id'">Pencarian</span>
            <span v-if="lang === 'en'">Search</span>
          </div>
        </div>
        <h2 class="pageTitle bcSm bcSearch">
          <template v-if="lang === 'id'">Hasil pencarian untuk "{{q}}"</template>
          <template v-if="lang === 'en'">Search result for "{{q}}"</template>
        </h2>
      </div>
      <div class="loading" v-if="loading"></div>
      <Contents :page="page" :search="true" v-else></Contents>
    </template>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Contents from '@/components/Contents.vue';
import NotFound from '@/components/NotFound.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  components: {
    Header,
    Contents,
    NotFound,
    Footer,
  },
  data() {
    return {
      scrolled: false,
      loading: true,
      page: null,
      q: '',
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.q = this.$route.query.q;
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    /**
     * No search query, display not found
     *
     */
    if (!this.q || this.q === '') {
      this.loading = false;
      return;
    }

    this.loading = false;
    this.page = {
      name: 'Pencarian',
      uri: '/search',
    };
  },
};
</script>

<style scoped lang="scss">
.bcCnt{
  padding: 40px 0 0;
  @media (max-width: 640px) {
    padding: 20px 0 0;
  }
  .breadcrumb{
    display: flex;
    padding: 0 0 10px;
    &.bcSm{
      max-width: 750px;
      margin: 0 auto;
    }
    &.bcSearch{
      max-width: 860px;
    }
    .bcItem{
      padding-right: 40px;
      position: relative;
      color: #767676;
      span{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
      }
      a{
        transition: all .3s ease;
        font-weight: 600;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
      }
      &:after{
        content: "";
        position: absolute;
        right: 15px; top: 0; bottom: 0;
        width: 10px;
        background-image: url(../assets/arrow-right-black.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .65;
      }
      &:last-child{
        &:after{
          display: none;
        }
      }
    }
  }
  .pageTitle{
    font-size: 34px;
    margin: 0;
    &.bcSm{
      max-width: 750px;
      margin: 0 auto;
    }
    &.bcSearch{
      max-width: 860px;
    }
  }
}
.loading{
  height: calc(100vh - 189px);
  background-image: url(../assets/loading.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 46px auto;
}
</style>
